import {Injectable} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { filter } from 'rxjs/operators';

import {SymptomSurveyModalComponent} from '@app/components/symptom-survey-modal/symptom-survey-modal.component';
import {ApiService} from '@app/services/api/api.service';
import {Logger} from '@app/services/logger/logger.service';
import { AuthService } from '@app/services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  constructor(private auth: AuthService, private modal: NgbModal, private api: ApiService) {
    this.auth.isLoggedIn$.pipe(
      filter(status => !status, true)
    ).subscribe(status => {
      if (!status) { return; } // skip if logging out
      const surveyStatus = this.getSurveyStatus();
      if (surveyStatus) { return; } // skip if survey has been completed

      Logger.banner({
        translate: 'symptomSurveyBanner',
        type: 'info',
        persist: true,
        close: true,
        action: this.openModal.bind(this)
      });
    });
  }

  // skip if cookie indicates survey was completed, otherwise check server-side
  getSurveyStatus() {
    let surveyStatus = !!localStorage.getItem('symptomSurveyCompleted');
    if (surveyStatus) { return true; }

    this.api.getSurveyStatus().subscribe(() => {
      localStorage.setItem('symptomSurveyCompleted', '1');
      surveyStatus = true;
    }, () => surveyStatus = false);

    return surveyStatus;
  }

  openModal() {
    this.modal.open(SymptomSurveyModalComponent, {
      centered: true,
      size: 'xl',
      windowClass: 'modal-fluid',
    }).result.then(
      _success => Logger.dismissBannerById('symptomSurveyBanner'),
      _error => {/* nothing to do on dismiss */}
    );
  }
}
